import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'mprd-mobile-number-submit',
  templateUrl: 'mobile-number-submit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileNumberSubmitComponent implements OnInit {
  MobileNumberSubmitForm: UntypedFormGroup;
  isMobileNumberSubmitFormHasErrors: boolean;
  @Input() showLoadingSpinner: boolean;
  @Output()
  mobileNumberSubmitFormStatusAndValue: EventEmitter<any> = new EventEmitter();
  @Output() mobileNumberSubmitCancel: EventEmitter<any> = new EventEmitter();

  constructor(private builder: UntypedFormBuilder) {}

  ngOnInit() {
    this.MobileNumberSubmitForm = this.builder.group({
      mobileNumber: [
        '',
        [Validators.required, Validators.pattern('(04)+[0-9]{8}$')],
      ],
    });

    this.MobileNumberSubmitForm.valueChanges.subscribe((value) => {
      this.isMobileNumberSubmitFormHasErrors =
        this.MobileNumberSubmitForm.get('mobileNumber').dirty &&
        !this.MobileNumberSubmitForm.pending &&
        !this.MobileNumberSubmitForm.get('mobileNumber').valid;
    });
  }

  onValidMobileNumberSubmit() {
    this.mobileNumberSubmitFormStatusAndValue.emit({
      mobileNumberSubmitFormStatus:
        this.MobileNumberSubmitForm.get('mobileNumber').valid,
      mobileNumber: this.MobileNumberSubmitForm.get('mobileNumber').value,
    });
  }

  onMobileNumberSubmitCancel() {
    this.mobileNumberSubmitCancel.emit({});
  }

  isNumberEmpty() {
    return this.MobileNumberSubmitForm.value.mobileNumber?.length === 0;
  }
}
